import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import { Autoplay, Navigation } from "swiper/modules";
import { FaArrowLeft, FaArrowRight, FaHotel, FaCheck } from "react-icons/fa";

import regency from "../assests/images/Regency Luxury Suites.webp";
import habtoor from "../assests/images/Al Habtoor Grand Resort.webp";
import bandra from "../assests/images/Al Bandar Rotana.webp";

const partners = [
    {
        id: 1,
        logo: regency,
        alt: "Regency Luxury Suites",
        name: "Regency Luxury Suites",
        location: "Dubai, UAE",
    },
    {
        id: 2,
        logo: habtoor,
        alt: "Al Habtoor Grand Resort",
        name: "Al Habtoor Grand Resort",
        location: "Dubai, UAE",
    },
    {
        id: 3,
        logo: bandra,
        alt: "Al Bandar Rotana",
        name: "Al Bandar Rotana",
        location: "Dubai, UAE",
    },
];

export default function TrustedPartners() {
    return (
        <section className="relative overflow-hidden bg-white py-16 sm:py-20 lg:py-24">

            {/* Soft Background Decorations */}
            <div className="absolute -top-32 -left-32 w-80 h-80 bg-[#D4A83F]/10 rounded-full blur-3xl"></div>

            <div className="absolute -bottom-40 -right-40 w-[450px] h-[450px] bg-[#174B5F]/5 rounded-full blur-3xl"></div>

            <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">

                {/* Heading */}
                <div className="max-w-3xl mx-auto text-center mb-12 sm:mb-14">

                    {/* Label */}
                    <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-[#002B45]/5 border border-[#002B45]/10 mb-5">

                        <span className="w-2 h-2 rounded-full bg-[#D4A83F]"></span>

                        <span className="text-xs sm:text-sm font-bold tracking-wide text-[#002B45]">
                            TRUSTED HOTEL PARTNERS
                        </span>

                    </div>

                    {/* Heading */}
                    <h2 className="text-3xl sm:text-4xl lg:text-5xl font-extrabold text-[#002B45] leading-tight">
                        Our Trusted
                        <span className="block text-[#174B5F]">
                            Hotel Partners
                        </span>
                    </h2>

                    {/* Description */}
                    <p className="text-slate-500 text-sm sm:text-base leading-7 mt-5 max-w-2xl mx-auto">
                        We partner with carefully selected hotels and resorts
                        across Dubai to provide exceptional stays and exclusive
                        accommodation experiences.
                    </p>

                </div>

                {/* Partner Slider */}
                <div className="relative">

                    {/* Desktop Previous */}
                    <button
                        className="partner-prev hidden lg:flex absolute -left-5 xl:-left-14 top-1/2 -translate-y-1/2 z-20 w-12 h-12 rounded-full bg-white border border-slate-200 text-[#002B45] items-center justify-center shadow-lg hover:bg-[#002B45] hover:text-white hover:border-[#002B45] transition-all duration-300"
                    >
                        <FaArrowLeft className="text-sm" />
                    </button>

                    {/* Desktop Next */}
                    <button
                        className="partner-next hidden lg:flex absolute -right-5 xl:-right-14 top-1/2 -translate-y-1/2 z-20 w-12 h-12 rounded-full bg-white border border-slate-200 text-[#002B45] items-center justify-center shadow-lg hover:bg-[#002B45] hover:text-white hover:border-[#002B45] transition-all duration-300"
                    >
                        <FaArrowRight className="text-sm" />
                    </button>

                    <Swiper
                        modules={[Autoplay, Navigation]}
                        spaceBetween={20}
                        slidesPerView={1}
                        loop={true}
                        navigation={{
                            nextEl: ".partner-next",
                            prevEl: ".partner-prev",
                        }}
                        autoplay={{
                            delay: 3500,
                            disableOnInteraction: false,
                            pauseOnMouseEnter: true,
                        }}
                        breakpoints={{
                            640: {
                                slidesPerView: 1,
                            },
                            768: {
                                slidesPerView: 2,
                            },
                            1024: {
                                slidesPerView: 3,
                            },
                        }}
                    >
                        {partners.map((partner, index) => (
                            <SwiperSlide key={partner.id}>

                                <div className="group relative bg-white rounded-3xl border border-slate-200 overflow-hidden shadow-[0_8px_30px_rgba(15,23,42,0.07)] hover:shadow-[0_20px_50px_rgba(15,23,42,0.13)] hover:-translate-y-2 transition-all duration-500">

                                    {/* Top Gold Line */}
                                    <div className="h-1 bg-gradient-to-r from-[#002B45] via-[#174B5F] to-[#D4A83F]"></div>

                                    {/* Image / Logo */}
                                    <div className="relative h-[250px] sm:h-[270px] bg-gradient-to-br from-slate-50 via-white to-slate-100 overflow-hidden">

                                        {/* Number */}
                                        <div className="absolute top-5 left-5 z-10 w-10 h-10 rounded-full bg-[#002B45] text-white flex items-center justify-center shadow-md">

                                            <span className="text-xs font-bold">
                                                {String(index + 1).padStart(2, "0")}
                                            </span>

                                        </div>

                                        {/* Hotel Icon */}
                                        <div className="absolute top-5 right-5 z-10 w-10 h-10 rounded-full bg-white border border-slate-200 flex items-center justify-center shadow-md">
                                            <FaHotel className="text-[#D4A83F] text-sm" />
                                        </div>

                                        {/* Logo */}
                                        <div className="absolute inset-0 flex items-center justify-center p-8">

                                            <img
                                                src={partner.logo}
                                                alt={partner.alt}
                                                className="max-w-[82%] max-h-40 object-contain group-hover:scale-105 transition-transform duration-700"
                                            />

                                        </div>

                                        {/* Bottom Fade */}
                                        <div className="absolute bottom-0 left-0 right-0 h-16 bg-gradient-to-t from-slate-100/50 to-transparent"></div>

                                    </div>

                                    {/* Content */}
                                    <div className="p-6">

                                        {/* Label */}
                                        <div className="flex items-center gap-2 mb-3">

                                            <span className="w-6 h-[2px] bg-[#D4A83F] group-hover:w-9 transition-all duration-300"></span>

                                            <span className="text-[10px] uppercase tracking-[0.18em] font-bold text-slate-400">
                                                Official Partner
                                            </span>

                                        </div>

                                        {/* Hotel Name */}
                                        <h3 className="text-xl font-extrabold text-[#002B45] line-clamp-1">
                                            {partner.name}
                                        </h3>

                                        {/* Location */}
                                        <p className="text-sm text-slate-500 mt-1">
                                            {partner.location}
                                        </p>

                                        {/* Footer */}
                                        <div className="flex items-center justify-between mt-5 pt-4 border-t border-slate-100">

                                            <div className="flex items-center gap-2">

                                                <span className="w-6 h-6 rounded-full bg-[#D4A83F]/10 flex items-center justify-center">
                                                    <FaCheck className="text-[#D4A83F] text-[9px]" />
                                                </span>

                                                <span className="text-xs font-semibold text-slate-500">
                                                    Trusted Stay
                                                </span>

                                            </div>

                                            <div className="w-9 h-9 rounded-full bg-[#002B45] text-white flex items-center justify-center group-hover:bg-[#D4A83F] group-hover:text-[#002B45] transition-all duration-300">
                                                →
                                            </div>

                                        </div>

                                    </div>

                                    {/* Hover Accent */}
                                    <div className="absolute bottom-0 left-8 right-8 h-[3px] bg-gradient-to-r from-[#002B45] via-[#174B5F] to-[#D4A83F] scale-x-0 group-hover:scale-x-100 transition-transform duration-500"></div>

                                </div>

                            </SwiperSlide>
                        ))}
                    </Swiper>

                </div>

                {/* Mobile Navigation */}
                <div className="flex lg:hidden justify-center gap-3 mt-8">

                    <button
                        className="partner-prev w-11 h-11 rounded-full bg-white border border-slate-200 text-[#002B45] flex items-center justify-center shadow-md hover:bg-[#002B45] hover:text-white transition-all duration-300"
                    >
                        <FaArrowLeft className="text-xs" />
                    </button>

                    <button
                        className="partner-next w-11 h-11 rounded-full bg-white border border-slate-200 text-[#002B45] flex items-center justify-center shadow-md hover:bg-[#002B45] hover:text-white transition-all duration-300"
                    >
                        <FaArrowRight className="text-xs" />
                    </button>

                </div>

                {/* Bottom Trust Statement */}
                <div className="flex flex-col sm:flex-row items-center justify-center gap-3 mt-10">

                    <div className="flex -space-x-2">

                        <div className="w-8 h-8 rounded-full bg-[#002B45] border-2 border-white flex items-center justify-center">
                            <FaHotel className="text-white text-xs" />
                        </div>

                        <div className="w-8 h-8 rounded-full bg-[#174B5F] border-2 border-white flex items-center justify-center">
                            <FaCheck className="text-white text-xs" />
                        </div>

                        <div className="w-8 h-8 rounded-full bg-[#D4A83F] border-2 border-white flex items-center justify-center">
                            <span className="text-[#002B45] text-xs font-bold">
                                +
                            </span>
                        </div>

                    </div>

                    <span className="text-sm text-slate-500">
                        Trusted partnerships with premium hotels across Dubai
                    </span>

                </div>

            </div>
        </section>
    );
}